import { Directive, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { appSettings } from 'app/appSettings';
import { ScrollService } from '../../../../core/services/scroll.service';

@Directive()
export abstract class UserListComponent implements OnChanges {
  dateFormat: string = appSettings.DATE_FORMAT_ANGULAR;
  @Input() pageNr: number;
  @Input() pageSize: number;
  @Input() totalItems: number;
  @Input() sortField: string;
  @Input() sortAscending: boolean;
  @Output() sortFieldChange: EventEmitter<string> = new EventEmitter();
  @Output() pageChange: EventEmitter<number> = new EventEmitter();
  @Output() sortAscendingChange: EventEmitter<boolean> = new EventEmitter();

  constructor(private scrollService: ScrollService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.users) {
      this.scrollService.scrollToElement('users-list');
    }
  }

  sort(field: string) {
    if (this.sortField === field) {
      this.sortAscending = !this.sortAscending;
      this.sortAscendingChange.emit(this.sortAscending);
    } else {
      this.sortField = field;
      this.sortFieldChange.emit(field);
      if (!this.sortAscending) {
        this.sortAscending = true;
        this.sortAscendingChange.emit(true);
      }
    }
  }

  sortBnd = this.sort.bind(this);
}
